import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalHeader" }
const _hoisted_3 = { class: "modalBody" }
const _hoisted_4 = { class: "form-group genericInputGroup" }
const _hoisted_5 = { class: "form-group genericInputGroup posRel" }
const _hoisted_6 = ["type"]
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-danger" }
const _hoisted_11 = { class: "modalFooter" }
const _hoisted_12 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Aggiungi account collegato",
          text: "Aggiungi account collegato"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        name: "login",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Email o username",
              text: "Email o username"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.email) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.vm.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Password",
              text: "Password"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: _ctx.showPassword ? 'text' : 'password',
            class: "form-control",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.password) = $event))
          }, null, 8, _hoisted_6), [
            [_vModelDynamic, _ctx.vm.password]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-default showPswBtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Mostra password",
              text: "Mostra password"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", _hoisted_8, [
            _createVNode(_component_localized_text, {
              localizedKey: "Login",
              text: "Login"
            })
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, "Annulla")
      ])
    ])
  ]))
}